import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { Environment } from 'utils';

interface IProps {
  children: React.ReactNode;
}

export const RouterProvider = ({ children }: IProps) => {
  return <Router basename={Environment.getPublicUrl()}>{children}</Router>;
};

export default RouterProvider;
